import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const notifications = [{
  name: 'Ana',
  action: 'acaba de añadir los bonos al carrito'
}, {
  name: 'Marta',
  action: 'compró el bono de recetas'
}, {
  name: 'Daniela',
  action: 'compró el bono de bebidas'
}, {
  name: 'Sofía',
  action: 'añadió el bono de recetas'
}, {
  name: 'Andrea',
  action: 'acaba de ver esta oferta'
}, {
  name: 'Verónica',
  action: 'añadió el pack completo'
}, {
  name: 'Gabriela',
  action: 'acaba de comprar el plan completo'
}, {
  name: 'Lucía',
  action: 'añadió las recetas a su pedido'
}, {
  name: 'Valentina',
  action: 'compró el pack de bebidas'
}, {
  name: 'Isabella',
  action: 'acaba de agregar los 3 bonos'
}, {
  name: 'Camila',
  action: 'añadió la lista de compras'
}, {
  name: 'Mariana',
  action: 'compró el plan con todos los bonos'
}, {
  name: 'Fernanda',
  action: 'acaba de desbloquear la oferta 2x1'
}, {
  name: 'Alejandra',
  action: 'añadió el recetario anti-inflamatorio'
}, {
  name: 'Natalia',
  action: 'compró las bebidas naturales'
}, {
  name: 'Carolina',
  action: 'acaba de completar su pedido'
}, {
  name: 'Diana',
  action: 'añadió los bonos hace un momento'
}, {
  name: 'Paola',
  action: 'compró el plan de 14 días con bonos'
}, {
  name: 'Claudia',
  action: 'acaba de agregar el recetario'
}, {
  name: 'Adriana',
  action: 'añadió la guía de bebidas'
}, {
  name: 'Teresa',
  action: 'compró el pack completo'
}, {
  name: 'Rosa',
  action: 'acaba de añadir los bonos'
}, {
  name: 'Elena',
  action: 'añadió las recetas y bebidas'
}, {
  name: 'Silvia',
  action: 'compró la lista de compras'
}, {
  name: 'Mónica',
  action: 'acaba de desbloquear todos los bonos'
}, {
  name: 'Beatriz',
  action: 'añadió el bono de recetas'
}, {
  name: 'Lorena',
  action: 'compró el plan con la oferta especial'
}, {
  name: 'Jimena',
  action: 'acaba de añadir los 3 bonos'
}, {
  name: 'Renata',
  action: 'compró el recetario anti-inflamatorio'
}, {
  name: 'Ximena',
  action: 'añadió el pack 2x1 a su pedido'
}, {
  name: 'Alicia',
  action: 'acaba de completar su compra'
}, {
  name: 'Rocío',
  action: 'compró las bebidas y la lista de compras'
}, {
  name: 'Estela',
  action: 'añadió los bonos hace unos segundos'
}, {
  name: 'Pilar',
  action: 'acaba de agregar el recetario'
}, {
  name: 'Susana',
  action: 'compró el plan completo con bonos'
}, {
  name: 'Inés',
  action: 'añadió la guía de bebidas naturales'
}, {
  name: 'Raquel',
  action: 'acaba de desbloquear la oferta'
}, {
  name: 'Lourdes',
  action: 'compró el bono de recetas'
}, {
  name: 'Catalina',
  action: 'añadió el pack completo al carrito'
}, {
  name: 'Viviana',
  action: 'acaba de comprar los 3 bonos'
}, {
  name: 'Graciela',
  action: 'añadió las recetas a su pedido'
}, {
  name: 'Irene',
  action: 'compró la lista de compras'
}, {
  name: 'Nuria',
  action: 'acaba de agregar los bonos'
}, {
  name: 'Celeste',
  action: 'añadió el recetario y las bebidas'
}, {
  name: 'Miriam',
  action: 'compró el plan con la oferta 2x1'
}, {
  name: 'Amparo',
  action: 'acaba de desbloquear todos los bonos'
}, {
  name: 'Yolanda',
  action: 'añadió los bonos hace un momento'
}, {
  name: 'Leticia',
  action: 'compró el bono de bebidas naturales'
}, {
  name: 'Rebeca',
  action: 'acaba de completar su pedido'
}, {
  name: 'Soledad',
  action: 'añadió el pack 2x1'
}];
export function PopNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before first notification
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 30000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Show for 3 seconds, then hide and wait 30 seconds before next
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % notifications.length);
        setIsVisible(true);
      }, 30000); // 30 seconds wait between notifications
    }, 3000); // Display for 3 seconds
    return () => clearTimeout(hideTimer);
  }, [isVisible]);
  const currentNotif = notifications[currentIndex];
  return <div className="fixed bottom-4 left-4 z-40 pointer-events-none" data-id="element-332">
      <AnimatePresence data-id="element-333">
        {isVisible && <motion.div initial={{
        opacity: 0,
        x: -50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.9,
        transition: {
          duration: 0.2
        }
      }} transition={{
        type: 'spring',
        damping: 20,
        stiffness: 300
      }} className="bg-white rounded-xl shadow-lg border border-beige p-3 pr-6 flex items-center max-w-xs" data-id="element-334">
            <div className="w-10 h-10 rounded-full bg-sage text-white flex items-center justify-center font-heading font-semibold flex-shrink-0 mr-3" data-id="element-335">
              {currentNotif.name.charAt(0)}
            </div>
            <div data-id="element-336">
              <p className="text-sm text-text-dark font-medium leading-tight" data-id="element-337">
                <span className="font-semibold" data-id="element-338">{currentNotif.name}</span>{' '}
                {currentNotif.action}
              </p>
              <div className="flex items-center mt-1" data-id="element-339">
                <div className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" data-id="element-340"></div>
                <span className="text-xs text-text-light" data-id="element-341">
                  hace unos segundos
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}